import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { ngfModule } from 'angular-file';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { SignaturePadModule } from '@viablelogic/ngx-signature-pad';
import { QuillModule } from 'ngx-quill';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import {
  PdfViewerModule, LinkAnnotationService, BookmarkViewService,
  MagnificationService, ThumbnailViewService, ToolbarService,
  NavigationService, TextSearchService, TextSelectionService,
  PrintService, FormDesignerService, FormFieldsService, AnnotationService, ValidateFormFieldsArgs
} from '@syncfusion/ej2-angular-pdfviewer';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgxCurrencyDirective } from "ngx-currency";
import { ImageCropperComponent } from 'ngx-image-cropper';

//Modal Component
import { AddAttachmentChecklistTemplateModalComponent } from './shared/add-attachment-checklist-template-modal/add-attachment-checklist-template-modal.component';
import { AddAttachmentModalComponent } from './shared/add-attachment-modal/add-attachment-modal.component';
import { AddressConfirmationModalComponent } from './employee/personal-info/address-confirmation-modal/address-confirmation-modal.component';
import { AdvanceItemModalComponent } from './checklist/manage-template/advance-item-modal/advance-item-modal.component';
import { CancelHolidayModalComponent } from './timeoff/cancel-holiday-modal/cancel-holiday-modal.component';
import { ChecklistItemClickSignModalComponent } from './shared/checklist-item-click-sign-modal/checklist-item-click-sign-modal.component';
import { ClockinJobModalComponent } from './home/clockin-job-modal/clockin-job-modal.component';
import { ClockoutModalComponent } from './home/clockout-modal/clockout-modal.component';
import { CreateNewChecklistModalComponent } from './checklist/create-new-checklist-modal/create-new-checklist-modal.component';
import { CreateNewTemplateModalComponent } from './checklist/templates/create-new-template-modal/create-new-template-modal.component';
import { DeleteBulletinModalComponent } from './admin/delete-bulletin-modal/delete-bulletin-modal.component';
import { DeleteOnboardEmployeeModalComponent } from './hiring/delete-onboard-employee-modal/delete-onboard-employee-modal.component';
import { DeleteResetOnboardTaskModalComponent } from './hiring/delete-reset-onboard-task-modal/delete-reset-onboard-task-modal.component';
import { DeleteUserGroupMembersModalComponent } from './admin/delete-user-group-members-modal/delete-user-group-members-modal.component';
import { DistributeChecklistsModalComponent } from './checklist/distribute-checklists-modal/distribute-checklists-modal.component';
import { DownloadAttachmentModalComponent } from './employee/benefit/download-attachment-modal/download-attachment-modal.component';
import { EditDependentModalComponent } from './employee/edit-dependent-modal/edit-dependent-modal.component';
import { EditExpenseModalComponent } from './employee/expense/edit-expense-modal/edit-expense-modal.component';
import { EditLongPromptModalComponent } from './shared/edit-long-prompt-modal/edit-long-prompt-modal.component';
import { EditPersonalModalComponent } from './careers/edit-personal-modal/edit-personal-modal.component';
import { EnableChecklistWorkflowModalComponent } from './checklist/manage-template/enable-checklist-workflow-modal/enable-checklist-workflow-modal.component';
import { FinalizeSubmitedModalComponent } from './employee/benefit/finalize-submited-modal/finalize-submited-modal.component';
import { FinalizeSubmitSignModalComponent } from './employee/benefit/finalize-submit-sign-modal/finalize-submit-sign-modal.component';
import { FloatingModalComponent } from './timeoff/floating-modal/floating-modal.component';
import { I9GenModalComponent } from './hiring/i9-gen-modal/i9-gen-modal.component';
import { InitializedAttachModalComponent } from './hiring/initialized-attach-modal/initialized-attach-modal.component';
import { InitializeModalComponent } from './performance/initialize-modal/initialize-modal.component';
import { NoteDetailActionModalComponent } from './hiring/note-detail-action-modal/note-detail-action-modal.component';
import { NoteModalComponent } from './shared/note-modal/note-modal.component';
import { OnboardingInvitationModalComponent } from './hiring/onboarding-invitation-modal/onboarding-invitation-modal.component';
import { OnboardInitModalComponent } from './hiring/onboard-init-modal/onboard-init-modal.component';
import { OnboardSubmittedModalComponent } from './careers/onboard-submitted-modal/onboard-submitted-modal.component';
import { PaperlessModalComponent } from './home/paperless-modal/paperless-modal.component';
import { PasswordWarningModalComponent } from './home/password-warning-modal/password-warning-modal.component';
import { RegisterTrainingPastClassesAttachmentModalComponent } from './employee/training/register-training-past-classes-attachment-modal/register-training-past-classes-attachment-modal.component';
import { RejectAllBenefitsModalComponent } from './employee/benefit/reject-all-benefits-modal/reject-all-benefits-modal.component';
import { RemoveClassModalComponent } from './employee/training/remove-class-modal/remove-class-modal.component';
import { ReviewCashoutRequestModalComponent } from './timeoff/review-cashout-request-modal/review-cashout-request-modal.component';
import { ReviewDDModalComponent } from './hiring/review-ddmodal/review-ddmodal.component';
import { ReviewECModalComponent } from './hiring/review-ecmodal/review-ecmodal.component';
import { ReviewI9ModalComponent } from './hiring/review-i9-modal/review-i9-modal.component';
import { ReviewIdenModalComponent } from './hiring/review-iden-modal/review-iden-modal.component';
import { ReviewOnboardingModalComponent } from './hiring/review-onboarding-modal/review-onboarding-modal.component';
import { ReviewTimeoffRequestModalComponent } from './timeoff/review-timeoff-request-modal/review-timeoff-request-modal.component';
import { ReviewW4ModalComponent } from './hiring/review-w4-modal/review-w4-modal.component';
import { SendBulletinEmailModalComponent } from './admin/send-bulletin-email-modal/send-bulletin-email-modal.component';
import { SubmitChecklistSignModalComponent } from './shared/submit-checklist-sign-modal/submit-checklist-sign-modal.component';
import { TimeoutModalComponent } from './shared/timeout-modal/timeout-modal.component';
import { TrainingBulkUpdateModalComponent } from './employee/training/training-bulk-update-modal/training-bulk-update-modal.component';
import { UpdateBenefitsModalComponent } from './employee/benefit/update-benefits-modal/update-benefits-modal.component';
import { UpdateDependentAddressModalComponent } from './employee/personal-info/update-dependent-address-modal/update-dependent-address-modal.component';
import { UserGroupModalComponent } from './shared/user-group-modal/user-group-modal.component';
import { ViewChecklistWorkflowModalComponent } from './checklist/view-checklist-workflow-modal/view-checklist-workflow-modal.component';
import { ViewCompanyHolidayModalComponent } from './timeoff/view-company-holiday-modal/view-company-holiday-modal.component';
import { ViewDetailModalComponent } from './employee/training/view-detail-modal/view-detail-modal.component';
import { ViewEditReviewerModalComponent } from './performance/view-edit-reviewer-modal/view-edit-reviewer-modal.component';
import { ViewGroupTimeoffModalComponent } from './timeoff/view-group-timeoff-modal/view-group-timeoff-modal.component';
import { ViewReportHistoryModalComponent } from './employee/benefit/view-report-history-modal/view-report-history-modal.component';
import { LookupModalComponent } from './office/lookup-modal/lookup-modal.component';
import { NamedLoginSetupModalComponent } from './admin/named-login-setup-modal/named-login-setup-modal.component';
import { ClockInModalComponent } from './sm/clock-in-modal/clock-in-modal.component';
import { ViewImageModalComponent } from './shared/view-image-modal/view-image-modal.component';
import { CompleteTripModalComponent } from './sm/complete-trip-modal/complete-trip-modal.component';
import { ClockOutModalComponent } from './sm/clock-out-modal/clock-out-modal.component';
import { CloseOutModalComponent } from './sm/close-out-modal/close-out-modal.component';
import { ContactListModalComponent } from './sm/contact-list-modal/contact-list-modal.component';
import { NewServiceItemModalComponent } from './sm/new-service-item-modal/new-service-item-modal.component';
import { ServiceListModalComponent } from './sm/service-list-modal/service-list-modal.component';
import { NewWorkOrderModalComponent } from './sm/new-work-order-modal/new-work-order-modal.component';
import { EditScheduledDateModalComponent } from './sm/edit-scheduled-date-modal/edit-scheduled-date-modal.component';
import { AttachmentDetailsModalComponent } from './sm/attachment-details-modal/attachment-details-modal.component';
import { ConfirmationModalComponent } from './sm/confirmation-modal/confirmation-modal.component';
import { ReadyToCompleteComponent } from './sm/ready-to-complete/ready-to-complete.component';

//shared Modal imports
import { AlertModalComponent } from './shared/alert-modal/alert-modal.component';
import { ErrorModalComponent } from './shared/error-modal/error-modal.component';
import { WarningModalComponent } from './shared/warning-modal/warning-modal.component';
import { ManageCatModalComponent } from './admin/expense-dashboard/manage-cat-modal/manage-cat-modal.component';
import { ManageMileageRateModalComponent } from './admin/expense-dashboard/manage-mileage-rate-modal/manage-mileage-rate-modal.component';
import { ReProcessExpenseModalComponent } from './admin/expense-dashboard/re-process-expense-modal/re-process-expense-modal.component';
import { EditVendorModalComponent } from './admin/expense-dashboard/edit-vendor-modal/edit-vendor-modal.component';
import { SendReminderExpenseModalComponent } from './admin/expense-dashboard/send-reminder-expense-modal/send-reminder-expense-modal.component';
import { ProcessExpenseModalComponent } from './admin/expense-dashboard/process-expense-modal/process-expense-modal.component';
import { ExpenseApprovalModalComponent } from './admin/expense-dashboard/expense-approval-modal/expense-approval-modal.component';
import { ExcelExportComponent } from './office/excel-export/excel-export.component';
import { ViewAttachmentComponent } from './report-gateway/view-attachment/view-attachment.component';
import { TextEditModalComponent } from './shared/text-edit-modal/text-edit-modal.component';
import { TextDisplayModalComponent } from './shared/text-display-modal/text-display-modal.component';
import { ActualEquipmentModalComponent } from './equipment/actual-equipment-modal/actual-equipment-modal.component';
import { OverrideModalComponent } from './admin/manage-employee-groups/override-modal/override-modal.component';
import { PreviewUserMembershipModalComponent } from './admin/manage-employee-groups/preview-user-membership-modal/preview-user-membership-modal.component';
import { ListViewModalComponent } from './shared/list-view-modal/list-view-modal.component';
import { ResetApprovalModalComponent } from './admin/expense-dashboard/reset-approval-modal/reset-approval-modal.component';
import { DropdownSelectModalComponent } from './shared/dropdown-select-modal/dropdown-select-modal.component';
import { AcknowledgeModalComponent } from './shared/acknowledge-modal/acknowledge-modal.component';
import { ConfirmModalComponent } from './shared/confirm-modal/confirm-modal.component';
import { NumberInputModalComponent } from './shared/number-input-modal/number-input-modal.component';
import { SearchSelectModalComponent } from './shared/search-select-modal/search-select-modal.component';
import { PaperlessSettingsModalComponent } from './admin/paperless-settings-modal/paperless-settings-modal.component';
import { WebixDatatablecomponent } from '../shared/component/time-off-grid/webix-datatable.component';
import { AddFieldTicketDayComponent } from './field/FieldTickets/add-field-ticket-day/add-field-ticket-day.component';
import { LoginOnboardCoPickModalComponent } from './account/login-onboard-co-pick-modal/login-onboard-co-pick-modal.component';
import { ViewExpenseAttachmentModalComponent } from './shared/view-expense-attachment-modal/view-expense-attachment-modal.component';
import { RejectLineModalComponent } from './approval/JobApproval/reject-line-modal/reject-line-modal.component';


@NgModule({
  declarations: [
    AddAttachmentChecklistTemplateModalComponent,
    AddAttachmentModalComponent,
    AddressConfirmationModalComponent,
    AdvanceItemModalComponent,
    AlertModalComponent,
    CancelHolidayModalComponent,
    ChecklistItemClickSignModalComponent,
    ClockinJobModalComponent,
    ClockoutModalComponent,
    CreateNewChecklistModalComponent,
    CreateNewTemplateModalComponent,
    DeleteBulletinModalComponent,
    DeleteOnboardEmployeeModalComponent,
    DeleteResetOnboardTaskModalComponent,
    DeleteUserGroupMembersModalComponent,
    DistributeChecklistsModalComponent,
    DownloadAttachmentModalComponent,
    EditDependentModalComponent,
    EditExpenseModalComponent,
    EditLongPromptModalComponent,
    EditPersonalModalComponent,
    EnableChecklistWorkflowModalComponent,
    ErrorModalComponent,
    FinalizeSubmitedModalComponent,
    FinalizeSubmitSignModalComponent,
    FloatingModalComponent,
    I9GenModalComponent,
    InitializedAttachModalComponent,
    InitializeModalComponent,
    NoteDetailActionModalComponent,
    NoteModalComponent,
    OnboardingInvitationModalComponent,
    OnboardInitModalComponent,
    OnboardSubmittedModalComponent,
    PaperlessModalComponent,
    PasswordWarningModalComponent,
    RegisterTrainingPastClassesAttachmentModalComponent,
    RejectAllBenefitsModalComponent,
    RemoveClassModalComponent,
    ReviewCashoutRequestModalComponent,
    ReviewDDModalComponent,
    ReviewECModalComponent,
    ReviewI9ModalComponent,
    ReviewIdenModalComponent,
    ReviewOnboardingModalComponent,
    ReviewTimeoffRequestModalComponent,
    ReviewW4ModalComponent,
    SendBulletinEmailModalComponent,
    SubmitChecklistSignModalComponent,
    TimeoutModalComponent,
    TrainingBulkUpdateModalComponent,
    UpdateBenefitsModalComponent,
    UpdateDependentAddressModalComponent,
    UserGroupModalComponent,
    ViewChecklistWorkflowModalComponent,
    ViewCompanyHolidayModalComponent,
    ViewDetailModalComponent,
    ViewEditReviewerModalComponent,
    ViewGroupTimeoffModalComponent,
    ViewReportHistoryModalComponent,
    WarningModalComponent,
    ManageCatModalComponent,
    ManageMileageRateModalComponent,
    ReProcessExpenseModalComponent,
    EditVendorModalComponent,
    SendReminderExpenseModalComponent,
    ProcessExpenseModalComponent,
    ExpenseApprovalModalComponent,
    LookupModalComponent,
    ExcelExportComponent,
    ViewAttachmentComponent,
    TextEditModalComponent,
    ClockInModalComponent,
    ViewImageModalComponent,
    CompleteTripModalComponent,
    ClockOutModalComponent,
    CloseOutModalComponent,
    TextDisplayModalComponent,
    ViewAttachmentComponent,
    ActualEquipmentModalComponent,
    ListViewModalComponent,
    ContactListModalComponent,
    NewServiceItemModalComponent,
    ServiceListModalComponent,
    NewWorkOrderModalComponent,
    EditScheduledDateModalComponent,
    AttachmentDetailsModalComponent,
    ConfirmationModalComponent,
    ReadyToCompleteComponent,
    OverrideModalComponent,
    PreviewUserMembershipModalComponent,
    ResetApprovalModalComponent,
    PreviewUserMembershipModalComponent,
    DropdownSelectModalComponent,
    AcknowledgeModalComponent,
    ConfirmModalComponent,
    NumberInputModalComponent,
    NamedLoginSetupModalComponent,
    SearchSelectModalComponent,
    PaperlessSettingsModalComponent,
    AddFieldTicketDayComponent,
    LoginOnboardCoPickModalComponent,
    ViewExpenseAttachmentModalComponent,
    RejectLineModalComponent,
    ActualEquipmentModalComponent
  ],
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    SharedModule,
    ngfModule,
    NgbModule,
    BsDatepickerModule,
    SignaturePadModule,
    QuillModule,
    PaginationModule,
    PdfViewerModule,
    DragDropModule,
    TimepickerModule,
    NgxCurrencyDirective,
    ImageCropperComponent
  ],
  exports: [
    AddAttachmentChecklistTemplateModalComponent,
    AddAttachmentModalComponent,
    AddressConfirmationModalComponent,
    AdvanceItemModalComponent,
    AlertModalComponent,
    CancelHolidayModalComponent,
    ChecklistItemClickSignModalComponent,
    ClockinJobModalComponent,
    ClockoutModalComponent,
    CreateNewChecklistModalComponent,
    CreateNewTemplateModalComponent,
    DeleteBulletinModalComponent,
    DeleteOnboardEmployeeModalComponent,
    DeleteResetOnboardTaskModalComponent,
    DeleteUserGroupMembersModalComponent,
    DistributeChecklistsModalComponent,
    DownloadAttachmentModalComponent,
    EditDependentModalComponent,
    EditExpenseModalComponent,
    EditLongPromptModalComponent,
    EnableChecklistWorkflowModalComponent,
    ErrorModalComponent,
    FinalizeSubmitedModalComponent,
    FinalizeSubmitSignModalComponent,
    FloatingModalComponent,
    I9GenModalComponent,
    InitializedAttachModalComponent,
    InitializeModalComponent,
    NoteDetailActionModalComponent,
    NoteModalComponent,
    OnboardingInvitationModalComponent,
    OnboardInitModalComponent,
    PaperlessModalComponent,
    PasswordWarningModalComponent,
    RegisterTrainingPastClassesAttachmentModalComponent,
    RejectAllBenefitsModalComponent,
    RemoveClassModalComponent,
    ReviewCashoutRequestModalComponent,
    ReviewDDModalComponent,
    ReviewECModalComponent,
    ReviewI9ModalComponent,
    ReviewIdenModalComponent,
    ReviewOnboardingModalComponent,
    ReviewTimeoffRequestModalComponent,
    ReviewW4ModalComponent,
    SendBulletinEmailModalComponent,
    SubmitChecklistSignModalComponent,
    TimeoutModalComponent,
    TrainingBulkUpdateModalComponent,
    UpdateBenefitsModalComponent,
    UpdateDependentAddressModalComponent,
    UserGroupModalComponent,
    ViewChecklistWorkflowModalComponent,
    ViewCompanyHolidayModalComponent,
    ViewDetailModalComponent,
    ViewEditReviewerModalComponent,
    ViewGroupTimeoffModalComponent,
    ViewReportHistoryModalComponent,
    WarningModalComponent,
    ManageCatModalComponent,
    ManageMileageRateModalComponent,
    ReProcessExpenseModalComponent,
    EditVendorModalComponent,
    SendReminderExpenseModalComponent,
    ProcessExpenseModalComponent,
    ExpenseApprovalModalComponent,
    LookupModalComponent,
    WebixDatatablecomponent,
    LookupModalComponent,
    DropdownSelectModalComponent,
    NamedLoginSetupModalComponent,
    PaperlessSettingsModalComponent
  ],
  providers: [LinkAnnotationService, BookmarkViewService, MagnificationService,
    ThumbnailViewService, ToolbarService, NavigationService, AnnotationService,
    TextSearchService, TextSelectionService, PrintService, FormDesignerService, FormFieldsService]
})
export class ModalsModule { }
